import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { getStylesMode } from 'ziphy-web-shared/basic/helpers';
import styles from './ToggleButton.module.scss';
const ToggleButton = ({ mode = ['simple', 'sm'], checkbox = {}, 
//
selected = false, disabled = false, invalid = false, 
//
label, onClick, 
//
className, }) => {
    checkbox = Object.assign({ mode: 'circle', position: 'left', multi: false }, checkbox);
    function getCheckbox(position) {
        return (_jsx("div", Object.assign({ className: styles[position] }, { children: _jsx("div", Object.assign({ className: classNames(styles.checkbox, checkbox.mode === 'circle' && styles.isCircle, checkbox.mode === 'square' && styles.isSquare, checkbox.multi && styles.isMulti) }, { children: _jsx(Icon, { className: styles.icon, type: checkbox.multi && !selected ? 'plus' : 'check' }) })) })));
    }
    const handleClick = (event) => {
        if (disabled)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, getStylesMode(mode, styles), selected && styles.isSelected, checkbox.position === 'none' && styles.noCheckbox, disabled && styles.isDisabled, invalid && styles.isInvalid, className), onClick: handleClick }, { children: [checkbox.position === 'left' && getCheckbox('left'), label && _jsx("div", Object.assign({ className: styles.content }, { children: label })), checkbox.position === 'right' && getCheckbox('right')] })));
};
export default observer(ToggleButton);
